var render = function render(_c,_vm){return _c('nav',{class:[ 'navbar', { '-mobile': _vm.props.isMobile } ]},[_c('a',{staticClass:"logo",attrs:{"href":_vm.props.homeUrl}},[_c('img',{staticClass:"img",attrs:{"alt":"logo","src":require('@assets/logo 1.svg')}})]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }